import { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TablePaginationActions, TableRow, TextField, Typography } from '@mui/material';

import moment from 'moment';

import { TablePaddingStyle, TableTheadStyle } from '../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../styles/DialogStyle';

import { BuscarAcuerdo } from '../connections/tribunal/AcuerdoConnection';
import { ObtenerTipoAcuerdo } from '../connections/catalogos/TipoAcuerdoConnection';
import { ObtenerSubTipoAcuerdo } from '../connections/catalogos/SubTipoAcuerdoConnection';

import { BuscarAcuerdoProps } from '../interfaces/tribunal/AcuerdoInterface';
import { TipoAcuerdoProps } from '../interfaces/catalogos/TipoAcuerdoInterface';
import { SubTipoAcuerdoProps } from '../interfaces/catalogos/SubTipoAcuerdoInterface';

import { usePages } from '../hooks/usePages';

interface Props {
    openDialog:             boolean;
    handleCloseDialog:      () => void;
    seleccionarAcuerdo:     ( acuerdo: BuscarAcuerdoProps  ) => void;
    idExpediente:           number,
    idIrregular:            number,
    idAmparo:               number,
    idExhortoRecibido:      number
}

export const DialogBuscarAcuerdo = ( { openDialog, handleCloseDialog, seleccionarAcuerdo, idExpediente, idIrregular, idAmparo, idExhortoRecibido }: Props ) => {

    const [rows, setRows] = useState<BuscarAcuerdoProps[]>( [] );
  
    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 3 );    

    const [tipoAcuerdo, setTipoAcuerdo] = useState(0);
    const [tipoAcuerdoArray, setTipoAcuerdoArray] = useState<TipoAcuerdoProps[]>( [] );

    const [subTipoAcuerdo, setSubTipoAcuerdo] = useState(0);
    const [subTipoAcuerdoArray, setSubTipoAcuerdoArray] = useState<SubTipoAcuerdoProps[]>( [] );

    const [fecha, setFecha] = useState( '' );  

    const [loadingSearch, setLoadingSearch] = useState( false );

    const CerraDialog = () => {

        handleCloseDialog();

        setSubTipoAcuerdo( 0 );
        setTipoAcuerdo( 0 );
        setFecha( '' );
        setRows( [] );
    }

    const handleSeleccionarAcuerdo = ( acuerdo: BuscarAcuerdoProps ) => {
        
        seleccionarAcuerdo( acuerdo );

        CerraDialog();
    }

    const handleBuscarAcuerdos = async () => {

        setLoadingSearch( true );
        resetPage();

        const params = {         
            idExpediente: idExpediente,
            idIrregular: idIrregular,
            idAmparo: idAmparo,   
            idExhortoRecibido: idExhortoRecibido,
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subTipoAcuerdo,
            fecha: fecha ? moment( fecha ).format('YYYY-MM-DD') : "",     
        }

        await BuscarAcuerdo( params ).then( resp => {     

            setTimeout(() => {

                setRows( resp );
                
                setLoadingSearch( false );

            }, 700); 

        });   

    }

     useEffect(() => {
            
            async function Obtener(){    
    
                await ObtenerTipoAcuerdo().then( resp => {              
                    setTipoAcuerdoArray( resp );                 
                });
    
            }
    
            if( openDialog ){
            
            Obtener();
        }
    
    }, [openDialog ]);

    useEffect(() => {

        async function Obtener(){           

            setSubTipoAcuerdo( 0 );
            setSubTipoAcuerdoArray( [] );

            if(tipoAcuerdo !== 0){   

                await ObtenerSubTipoAcuerdo(tipoAcuerdo).then( response => {
         
                    setSubTipoAcuerdoArray( response );                 

                });

            }       

        }

        Obtener();

    }, [ tipoAcuerdo ]);

    const CerrarDialog = () => {

        handleCloseDialog();

        setTipoAcuerdo(0);
        setSubTipoAcuerdo(0);
        setFecha( '' );
               
        setRows( [] );
    }

    return (
        <Dialog 
            maxWidth='md' 
            fullWidth={true}
            open={ openDialog } 
        >

            <DialogTitle>
                Buscar Persona
            </DialogTitle>
        
            <DialogContent sx={ DialogContentStyle }>
                
                <Grid container spacing={3} mt={3}>                                                 
                
                    <Grid size={{ md: 6, xs: 12 }} >

                        <FormControl required fullWidth>
                            
                            <InputLabel>Tipo de acuerdo</InputLabel>
                                                            
                            <Select                                                                          
                                label="Tipo de acuerdo"
                                value={ tipoAcuerdo }
                                onChange={ ( e ) => setTipoAcuerdo( parseInt( e.target.value.toString() ) ) }
                            >
                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>      
                                {
                                        tipoAcuerdoArray
                                    .map( ( e ) => (
                                        <MenuItem key={ e.idTipoAcuerdo } value={ e.idTipoAcuerdo }>{ e.descripcion }</MenuItem>                                                        
                                    ))
                                }  
                            </Select>

                        </FormControl>

                    </Grid> 
    
                    <Grid size={{ md: 6, xs: 12 }} >

                        <FormControl required fullWidth>
                            
                            <InputLabel>Subtipo de acuerdo</InputLabel>
                                                            
                            <Select                                                                          
                                label="Subtipo de acuerdo"
                                value={ subTipoAcuerdo }
                                onChange={ ( e ) => setSubTipoAcuerdo( parseInt( e.target.value.toString() ) ) }
                                disabled={ tipoAcuerdo === 0 || subTipoAcuerdoArray.length === 0 }
                            >
                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>      
                                {
                                    subTipoAcuerdoArray
                                    .map( ( e ) => (
                                        <MenuItem key={ e.idSubTipoAcuerdo } value={ e.idSubTipoAcuerdo }>{ e.descripcion }</MenuItem>                                                        
                                    ))
                                }  
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }} >

                        <TextField  
                            fullWidth                            
                            label="Fecha"
                            type="date"              
                            value={ fecha }    
                            onChange={ ( e ) => { setFecha( e.target.value ); } } 
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                }
                            }}                               
                        />
                                    
                    </Grid>

                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'right', marginTop: '0.5em' }} >
                        
                        <Button
                            fullWidth                   
                            variant="contained"     
                            loading={ loadingSearch }    
                            onClick={ handleBuscarAcuerdos }
                            disabled={ tipoAcuerdo === 0 && fecha === '' }
                        >
                            Buscar
                        </Button >

                    </Grid>           

                    <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 2 }} >
                        
                        <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                                    
                            <Table sx={{ minWidth: 500 }}>       
                                                                    
                                <TableHead sx={{ ...TableTheadStyle }}>
                
                                    <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  

                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%' }}>Tipo de acuerdo</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%' }}>Sub tipo de acuerdo</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>Fecha</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> </TableCell>

                                    </TableRow>

                                </TableHead>    
                                            
                                <TableBody>

                                    {
                                        (
                                            rowsPerPage > 0
                                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : rows
                                        ).map( ( elem, index ) => {

                                            const { tipoAcuerdo, nombre, fecha,  } = elem;

                                            return <TableRow key={ index }>

                                                <TableCell> { tipoAcuerdo } </TableCell>

                                                <TableCell> { nombre } </TableCell> 

                                                <TableCell> { fecha ? moment( fecha ).format( 'DD-MM-YYYY' ) : ''  } </TableCell>
                                                
                                                <TableCell> 

                                                    <Button 
                                                        size="small" 
                                                        variant='contained'
                                                        onClick={ () => handleSeleccionarAcuerdo( elem ) }
                                                    >
                                                        Seleccionar
                                                    </Button>

                                                </TableCell>

                                            </TableRow>

                                        })
                                    }

                                    {
                                        rows.length === 0 
                                        &&                                                    
                                            <TableRow>

                                                <TableCell
                                                    colSpan={9}
                                                    align="center"
                                                >

                                                    {
                                                        loadingSearch
                                                        ?
                                                            <Typography variant="caption" color='secondary'> Buscando.... </Typography>
                                                        :
                                                            <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                    }

                                                </TableCell>

                                            </TableRow>                                                    
                                    }

                                </TableBody>    

                                <TableFooter>

                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[ ]}
                                            colSpan={6}
                                            count={rows.length}                                        
                                            rowsPerPage={rowsPerPage}
                                            page={page}                                                                                
                                            onPageChange={ handleChangePage }
                                            onRowsPerPageChange={ handleChangeRowsPerPage }
                                            ActionsComponent={ TablePaginationActions }

                                            labelDisplayedRows={
                                                ({ from, to, count }) => {
                                                    return '' + from + '-' + to + ' de ' + count
                                                }
                                            }
                                        />
                                    </TableRow>

                                </TableFooter>

                            </Table>
                        
                        </TableContainer>

                    </Grid>           
                    
                </Grid>
                
            </DialogContent>

            <DialogActions sx={ DialogActionsStyle }>

                <Button 
                    color="secondary" 
                    onClick={ CerrarDialog }
                >
                    Cancelar
                </Button>

            </DialogActions>

        </Dialog>
    )
}
